import { render, staticRenderFns } from "./comp_FooterSocialsList.vue?vue&type=template&id=2d964cc0&scoped=true&"
import script from "./comp_FooterSocialsList.vue?vue&type=script&lang=js&"
export * from "./comp_FooterSocialsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d964cc0",
  null
  
)

export default component.exports